function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M340.167 21.2943C304.699 12.221 261.497 25.0749 244.33 32.6359C141.775 53.2189 133.714 14.1533 60.269 12.053C-13.1764 9.95267 -4.66745 70.8615 9.66335 95.645C23.9941 120.429 60.7168 85.1435 89.3784 83.4633C118.04 81.783 121.175 125.889 187.007 112.447C252.839 99.0055 249.704 106.567 318.671 112.447C387.638 118.328 401.073 77.1624 401.969 59.9399C402.865 42.7174 384.503 32.6359 340.167 21.2943Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.5,
  cy: 44.4998,
  r: 26.5,
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 197.5,
  cy: 72.4998,
  r: 72.5,
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 278,
  cy: 94.9998,
  r: 42,
  fill: "url(#paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.9999,
  cy: 64.9998,
  r: 15,
  fill: "url(#paint3_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 155.343,
  y1: 92.157,
  x2: 96.9999,
  y2: 10.2706,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#315EFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#315EFB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 284.617,
  y1: 202.883,
  x2: 125,
  y2: -21.1461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#28BC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28BC00",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 323.48,
  y1: 121.632,
  x2: 212.067,
  y2: 114.734,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEEFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 113.243,
  y1: 74.5113,
  x2: 73.4523,
  y2: 72.0476,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DADAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEEFF",
  stopOpacity: 0
})));

function SvgTokens5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 145,
    viewBox: "0 0 402 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens5);
export default __webpack_public_path__ + "static/media/tokens_5.1137cc29.svg";
export { ForwardRef as ReactComponent };